













import { genVuexComputeds } from '@/main/pages/editFactory';
import { EditStoreMixin } from '@/main/pages/editStoreMixin';

import ZakazkaSelect from '../Select.vue';
import { types } from '../../store/types';
import { store } from '../../store/edit';

export default EditStoreMixin.extend({
	name: 'ZakazkyRef',
	components: {
		ZakazkaSelect,
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_REF_SELECT_MAPPER}`,
			};
		},
	},
});
